export default {
    EVIDENCE_TYPE_KH: 3,
    EVIDENCE_TYPE_RYCZALT: 2,
    EVIDENCE_TYPE_KPIR: 1,
    VAT_REGISTER_VAT_OUTCOME: 1,
    VAT_REGISTER_TYPE_WNT: 3,
    VAT_REGISTER_VAT_INCOME: 8,
    VAT_REGISTER_TYPE_WDT: 10,
};